import React, { Component } from 'react';
import lodashFilter from 'lodash/filter';
import lodashForEach from 'lodash/forEach';
import lodashMap from 'lodash/map';
import PropTypes from 'prop-types';
import ReactDataGrid from 'react-data-grid';
import { Data, Toolbar } from 'react-data-grid-addons';
import { Translate } from 'react-redux-i18n';
import { Button, ButtonToolbar, Row, Col } from 'react-bootstrap';
import { RowRenderer } from '../../Common/rowRenderer';
import { ROOT_URL, ROOT_API_URL, companyCodeTitle } from '../../../actions/root_url';
import axios from 'axios';

const isJML = ROOT_API_URL === "https://jml-scm.truckxi.com/api/";
const isUSPride = ROOT_API_URL === 'https://uspride-scm.truckxi.com/api/' || ROOT_URL === 'https://uspride-scm.truckxi.com/api/';

const propTypes = {
};

const defaultProps = {
};

class SkusTableModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rows: [],
      filters: null,
      sortColumn: null,
      sortDirection: null,
    };
  }

  componentDidMount() {
    let rows = JSON.parse(this.props.skus);
    rows.map((r,i) => {
      rows[i].idx = i+1;
    });
    this.setState({rows});

    if (isUSPride) {
      this.refreshTable();
    }
    // this.setState({
    //   rows: JSON.parse(this.props.skus)
    // })
  }

  refreshTable = () => {
    let { Product_id} = this.props;
    let usTemp = [];
    if (isUSPride) {
      axios
      .get(
        `${ROOT_URL}v2/product/sku/?product_id=` + Product_id,
        {headers: {Authorization: `Bearer ${localStorage.getItem("token")}`,},},
      )
      .then(
        (res) => {
          res.data.map(r=>{
            usTemp.push(r);
          });
          console.log("uspride", usTemp);
          this.setState({rows: usTemp});
        },
        (err) => {
          if (err.data) {
            alert(err.data);
          } else {
            alert("Server issue detected, please contact admin.");
          }
        }
      );
    }
  }

  uspDel = (data) => {
    axios.delete(
      `${ROOT_URL}v2/product/sku/` + data.id,
      {
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
      }
    )
    .then(
      (res) => {
        // alert("SKU Deleted");
        this.refreshTable();
      },
      (err) => {
        if (err.data) {
          alert(err.data);
        } else {
          alert("Server issue detected, please contact admin.");
        }
      }
    );
  }

  addSKU = () => {
    let { Product_id} = this.props;
    let {rows} = this.state;
    const newRow = {
      name: '',
      sku: '',
      product: Product_id,
      idx: Number(rows.length) + 1,
    }
    this.setState({
      rows: [...this.state.rows, newRow]
    })
  }

  delSKU = (idx) => {
    let {rows} = this.state;
    rows = rows.filter((obj) => {
      const match = obj.idx !== idx;
      return match;
    });
    rows.map((r,i) => {
      rows[i].idx = i+1;
    });
     this.setState({
      rows
    });
  }

  saveSKU = () => {
    let {rows} = this.state;
    let tempRows = [];
    rows.map((r,i) => {
      if (r.name || r.sku) {
        tempRows.push({name: r.name, sku: r.sku});
      }
    });
    var str = JSON.stringify(tempRows);
    this.props.updateSKU(str);
  };

  renderExcel() {
    let { Product_id} = this.props;
    let disabled = false;
    if (!Product_id) {
      disabled = true;
    }
    const exportUrl = `${ROOT_URL}v1/product/sku_export/${this.props.Product_id}?Bearer=${localStorage.getItem("token")}`;

    return (
      <Button
        bsStyle="success"
        type="button"
        href={exportUrl}
        disabled={disabled}
      >
        <em className="fa fa-download" />
        <Translate value="excel" />
      </Button>
    );
  }

  render() {
    const getRows = () => Data.Selectors.getRows(this.state);

    const getSize = () => getRows().length;

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };

    const handleGridSort = (sortColumn, sortDirection) => {
      const state = Object.assign({}, this.state, { sortColumn, sortDirection });
      this.setState(state);
    };

    const onClearFilters = () => {
      this.setState({ filters: {} });
    };

    const handleRowUpdated = (row) => {
      var newRow = this.state.rows;

      let {rows} = this.state;
      let uspTemp = null;
      if (isUSPride) {
        if (rows && rows[row.rowIdx] && rows[row.rowIdx].id && rows[row.rowIdx].sku && rows[row.rowIdx].product) {
          uspTemp = {name: rows[row.rowIdx].name, sku: rows[row.rowIdx].sku, product: rows[row.rowIdx].product}
          
          setTimeout(() => {
            axios.put(
              `${ROOT_URL}v2/product/sku/` + rows[row.rowIdx].id,
              uspTemp,
              {
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
              },
            )
              .then((response) => {
                setTimeout(() => {
                  this.refreshTable();
                }, 300);
                  // alert("SKU Saved");
              }, (err) => {
                if (err.status === 500 || err.status === 404) {
                  err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
              }
              alert(JSON.stringify(err.data));
              this.refreshTable();
              // row.updated = {sku: ''};
              // newRow[row.rowIdx] = {
              //     ...newRow[row.rowIdx],
              //     ...row.updated,
              //   }
              //   this.setState({
              //     rows: newRow,
              //   });
              });
          }, 200);
        } else if (rows && rows[row.rowIdx] && !rows[row.rowIdx].id && rows[row.rowIdx].sku && rows[row.rowIdx].product) {
          uspTemp = {name: rows[row.rowIdx].name, sku: rows[row.rowIdx].sku, product: rows[row.rowIdx].product}
          setTimeout(() => {
          axios.post(
            `${ROOT_URL}v2/product/sku/`,
            uspTemp,
            {
              headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
            },
          )
            .then((response) => {
              setTimeout(() => {
                this.refreshTable();
              }, 300);
                    // alert("SKU Saved");
            }, (err) => {
              if (err.status === 500 || err.status === 404) {
                err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
            }
            alert(JSON.stringify(err.data));
            this.refreshTable();
            // row.updated = {sku: ''};
            // newRow[row.rowIdx] = {
            //   ...newRow[row.rowIdx],
            //   ...row.updated,
            // }
            // this.setState({
            //   rows: newRow,
            // });
            });
          }, 200);
        } else {

        }
      }

      newRow[row.rowIdx] = {
        ...newRow[row.rowIdx],
        ...row.updated,
      }
      this.setState({
        rows: newRow,
      })
    };

    const columns = [
      {
        key: 'name',
        name: <Translate value="name" />,
        resizable: true,
        editable: true,
        width: 180,
        sortable: true,
        filterable: true,
      },
      {
        key: 'sku',
        name: <Translate value="sku" />,
        resizable: true,
        editable: true,
        width: 180,
        sortable: true,
        filterable: true,
      },
      {
        key: 'idx',
        name: <Translate value="operation" />,
        resizable: true,
        width: 90,
        formatter: ({ value, dependentValues }) => (
          <div
              style={{ width: '100%', height: '100%' }}
              // onDoubleClick={() => {
              //   this.delSKU(value);
              // }}
          >
            {
              (dependentValues.id || !isUSPride) &&
                <Button
                bsStyle="danger"
                className="textAlignStyle"
                style={{ height: '23px', width: '39px', padding: '0px' }}
                onClick={() => {
                  if (isUSPride) {
                    this.uspDel(dependentValues);
                  } else {
                    this.delSKU(value);
                  }
                }}
              >X
              </Button>
      }
          </div>
      ),
      getRowMetaData: row => row,
      },
    ];

    return (
      <Row>
        <Col sm={12}>
          <ButtonToolbar>
            <Button
              type="button"
              bsStyle="primary"
              onClick={this.addSKU}
            >
              <em className="fa fa-plus" /><Translate value="add" />
            </Button>
            {
              !isUSPride &&
              <Button
                type="button"
                bsStyle="primary"
                onClick={this.saveSKU}
              >
                <em className="fa fa-save" /><Translate value="save" />
              </Button>
            }
            {isJML && this.renderExcel()}
          </ButtonToolbar>
          <div style={{ maxWidth: '100%', marginTop: '5px' }} id="linkProductsModal-dataGrid1">
            <ReactDataGrid
              rowKey="skus_table"
              enableCellSelect
              onRowUpdated={handleRowUpdated}
              rowHeight={25}
              minHeight={250}
              columns={columns}
              rowGetter={rowGetter}
              rowsCount={getSize()}
            />
          </div>
        </Col>
      </Row>
    );
  }
}

SkusTableModal.propTypes = propTypes;
SkusTableModal.defaultProps = defaultProps;

export default SkusTableModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Products/components/SkusModal.jsx